import styled from 'styled-components';

import { blue, whitesmoke } from 'utils/style/colors';

export const PrintInfo = styled.div`
  width: 100%;
  background: ${blue};
  color: var(--exact-white);
  padding: 5px 0;
  text-align: center;
  @media print {
    display: none;
  }
`;

export const ReportContent = styled.div`
  width: 900px;
  margin: 3em auto;
`;

export const ChartSection = styled.section`
  padding-bottom: 2rem;
`;

export const ReportTitle = styled('div')`
  background-color: ${whitesmoke};
  padding: 1em;
  border-radius: 10px;
  width: 100%;
  margin-bottom: 1em;
  display: flex;
  justify-content: space-between;
`;
